// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f0997079","703":"2cdb412f"}[chunkId] + ".chunk.js";
};